import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	//fieldsMap.get('code'),
	fieldsMap.get('display_name'),
	fieldsMap.get('status')
];

const config: IFormConfig = { 
	title: 'Modifica Dominio',
	editTitle: 'Modifica Dominio',
	fields: formFields 
};

export default config;
